export default __webpack_public_path__ + "static/media/20220203_122320.12837e28.png";